document.querySelectorAll("slide-show").forEach((component) => {
  const slider = component.querySelector(".slideshow");
  const prevBtn = component.querySelector('[name="prev"]');
  const nextBtn = component.querySelector('[name="next"]');

  let startX = 0;
  let moved = false;
  let isDown = false;
  let lastX = 0;
  let velocity = 0;

  const MIN_DRAG = 6;      
  const SWIPE_DISTANCE = 25; 
  const SWIPE_SPEED = 0.20;  

  let startTime = 0;

  slider.addEventListener("click", function (e) {
    if (moved) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    moved = false;
    lastX = startX = e.pageX;
    startTime = Date.now();
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;

    const dx = e.pageX - startX;
    const dt = Date.now() - startTime;

    if (Math.abs(dx) > MIN_DRAG) moved = true;

    velocity = (e.pageX - lastX) / dt;
    lastX = e.pageX;
  });

  window.addEventListener("mouseup", (e) => {
    if (!isDown) return;
    isDown = false;

    const endX = e.pageX;
    const distance = endX - startX;
    const elapsed = (Date.now() - startTime) / 1000;

    if (moved) {
      if (elapsed < SWIPE_SPEED) {
        if (distance > 10 && prevBtn) prevBtn.click();
        else if (distance < -10 && nextBtn) nextBtn.click();
        return;
      }

      if (distance > SWIPE_DISTANCE && prevBtn) prevBtn.click();
      else if (distance < -SWIPE_DISTANCE && nextBtn) nextBtn.click();
      return;
    }

  });

  slider.addEventListener("dragstart", (e) => e.preventDefault());
});